import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import {IconButton, IconButtonProps, styled} from '@mui/material';
type RotationDirections = 'left' | 'right' | 'up' | 'down';
const rotationMap: Record<RotationDirections, string> = {
    left: 'rotate(270deg)',
    right: 'rotate(0deg)',
    up: 'rotate(-90deg)',
    down: 'rotate(180deg)',
};
interface AppArrowRotationIconButtonProps extends Omit<IconButtonProps, 'children'> {
    selectRotation?: RotationDirections;
    unSelectRotation?: RotationDirections;
    isSelected: boolean;
}

export const AppArrowRotationIconButton: React.FC<AppArrowRotationIconButtonProps> = props => {
    return (
        <AppArrowRotationIconButtonBase {...props}>
            <NavigateNextIcon />
        </AppArrowRotationIconButtonBase>
    );
};

export default AppArrowRotationIconButton;

const AppArrowRotationIconButtonBase = styled(IconButton, {
    shouldForwardProp: prop => prop !== 'isSelected' && prop !== 'selectRotation' && prop !== 'unSelectRotation',
})<AppArrowRotationIconButtonProps>(({
    selectRotation = 'up',
    unSelectRotation = 'right',
    isSelected = false,
    theme,
}) => {
    const rotation = isSelected ? rotationMap[selectRotation] : rotationMap[unSelectRotation];
    return {
        transform: rotation,
        color: theme.palette.secondary.dark,
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
        opacity: 0.8,
    };
});
